import { DefaultState } from 'store/types';

export const GET_PROVIDER_LODGING_POLICY_REQUEST = 'GET_PROVIDER_LODGING_POLICY_REQUEST';
export const GET_PROVIDER_LODGING_POLICY_SUCCESS = 'GET_PROVIDER_LODGING_POLICY_SUCCESS';
export const GET_PROVIDER_LODGING_POLICY_FAILURE = 'GET_PROVIDER_LODGING_POLICY_FAILURE';
export const GET_PROVIDER_LODGING_POLICY_CLEAR = 'GET_PROVIDER_LODGING_POLICY_CLEAR';

export interface GetProviderLodgingPolicy {
  id: string;
  policyName: string;
  policy: string;
  status: string;
}

export type GetProviderLodgingPolicyState = DefaultState & {
  contents?: GetProviderLodgingPolicy;
};

interface GetProviderLodgingPolicyRequest {
  type: typeof GET_PROVIDER_LODGING_POLICY_REQUEST;
}

interface GetProviderLodgingPolicySuccess {
  type: typeof GET_PROVIDER_LODGING_POLICY_SUCCESS;
  contents: GetProviderLodgingPolicy;
}

interface GetProviderLodgingPolicyFailure {
  type: typeof GET_PROVIDER_LODGING_POLICY_FAILURE;
}

interface GetProviderLodgingPolicyClear {
  type: typeof GET_PROVIDER_LODGING_POLICY_CLEAR;
}

export type GetProviderLodgingPolicyActionTypes = GetProviderLodgingPolicyRequest | GetProviderLodgingPolicySuccess | GetProviderLodgingPolicyFailure | GetProviderLodgingPolicyClear;